/* Kōraru PLP — quick add by size and load more. Loaded by sections/plp-grid.liquid.
   Cart add + drawer refresh mirror snippets/quick-size-add.liquid. */
(function () {
  if (window.__plpEditorialReady) return;
  window.__plpEditorialReady = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- open / close (touch) ---------- */
  function setOpen(card, open) {
    card.classList.toggle('is-qa-open', open);
    var t = card.querySelector('.plp-qa__toggle');
    if (t) {
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      t.setAttribute('aria-label', t.getAttribute(open ? 'data-label-close' : 'data-label-open'));
    }
  }
  function closeAll(except) {
    document.querySelectorAll('.plp-card.is-qa-open').forEach(function (c) {
      if (c !== except) setOpen(c, false);
    });
  }

  /* ---------- cart ---------- */
  function getDrawer() { return document.querySelector('cart-drawer'); }

  function sectionIdsFor(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { return drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    var sec = drawer && drawer.closest('.shopify-section');
    if (sec) return [sec.id.replace('shopify-section-', '')];
    return null;
  }

  function refreshDrawer(res) {
    if (!res || !res.sections) return;
    var selectors = ['#CartDrawer', '#cart-icon-bubble', '.cart-count-bubble', '.cart-count'];
    Object.keys(res.sections).forEach(function (key) {
      if (!res.sections[key]) return;
      var parsed = new DOMParser().parseFromString(res.sections[key], 'text/html');
      selectors.forEach(function (sel) {
        var incoming = parsed.querySelector(sel);
        var current = document.querySelector(sel);
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      });
    });
    var drawer = getDrawer();
    if (drawer) drawer.classList.remove('is-empty');
  }

  function syncCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
        });
      })
      .catch(function () {});
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    drawer.classList.add('active', 'animate');
    document.body.classList.add('overflow-hidden');
  }

  function add(btn) {
    var id = btn.getAttribute('data-variant-id');
    var qa = btn.closest('.plp-qa');
    var card = btn.closest('.plp-card');
    if (!id || !qa || qa.classList.contains('is-busy')) return;
    qa.classList.add('is-busy');

    var label = qa.querySelector('.plp-qa__label');
    var labelText = label ? label.textContent : '';
    var drawer = getDrawer();
    var ids = sectionIdsFor(drawer);
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (ids) { body.sections = ids; body.sections_url = window.location.pathname; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw res;
        btn.classList.add('is-added');
        if (label) label.textContent = qa.getAttribute('data-added-label') || 'Added';
        try { refreshDrawer(res); } catch (e) {}
        syncCount();
        setTimeout(function () {
          if (card) setOpen(card, false);
          openDrawer(drawer);
        }, 450);
        setTimeout(function () {
          qa.classList.remove('is-busy');
          btn.classList.remove('is-added');
          if (label) label.textContent = labelText;
        }, 1800);
      })
      .catch(function (err) {
        qa.classList.remove('is-busy');
        if (!label) return;
        label.textContent = (err && err.description) || 'Please try again';
        setTimeout(function () { label.textContent = labelText; }, 3000);
      });
  }

  /* ---------- load more (click, or automatically as it nears the viewport) ---------- */
  function loadMore(link) {
    if (link.getAttribute('data-loading')) return;
    link.setAttribute('data-loading', '1');
    link.classList.add('is-loading');

    var sectionId = link.getAttribute('data-section');
    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('PlpGrid-' + sectionId);
        doc.querySelectorAll('#PlpGrid-' + sectionId + ' > .plp-grid__item').forEach(function (li) {
          grid.appendChild(document.importNode(li, true));
        });
        var next = doc.querySelector('[data-plp-more]');
        if (next) {
          link.href = next.getAttribute('href');
          link.removeAttribute('data-loading');
          link.classList.remove('is-loading');
          if (link.__plpIO) { link.__plpIO.unobserve(link); link.__plpIO.observe(link); }
        } else {
          var wrap = link.closest('.plp-more');
          if (link.__plpIO) link.__plpIO.disconnect();
          if (wrap) wrap.remove();
        }
      })
      .catch(function () { window.location.href = link.href; });
  }

  function watch() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-plp-more]').forEach(function (link) {
      if (link.__plpIO) return;
      link.__plpIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) loadMore(link); });
      }, { rootMargin: '0px 0px 800px 0px' });
      link.__plpIO.observe(link);
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.plp-qa__toggle');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('.plp-card');
      var open = !card.classList.contains('is-qa-open');
      closeAll(card);
      setOpen(card, open);
      return;
    }
    var size = e.target.closest('.plp-card .plp-size');
    if (size) {
      e.preventDefault();
      if (!size.disabled) add(size);
      return;
    }
    var more = e.target.closest('[data-plp-more]');
    if (more) {
      e.preventDefault();
      loadMore(more);
      return;
    }
    if (!e.target.closest('.plp-qa')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  document.addEventListener('shopify:section:load', watch);
})();
